import * as React from "react";

const InputSearch: React.FC = () => (
    <svg
        width="18px"
        height="18px"
        viewBox="0 0 18 18"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill="currentColor"
            d="M8.11111111,0 C12.5907541,0 16.2222222,3.63146814 16.2222222,8.11111111 C16.2222222,9.99054845 15.5830011,11.7206877 14.5101063,13.0959813 L17.7071068,16.2928932 C18.0976311,16.6834175 18.0976311,17.3165825 17.7071068,17.7071068 C17.3165825,18.0976311 16.6834175,18.0976311 16.2928932,17.7071068 L13.0959813,14.5101063 C11.7206877,15.5830011 9.99054845,16.2222222 8.11111111,16.2222222 C3.63146814,16.2222222 0,12.5907541 0,8.11111111 C0,3.63146814 3.63146814,0 8.11111111,0 Z M8.11111111,2 C4.73603764,2 2,4.73603764 2,8.11111111 C2,11.4861846 4.73603764,14.2222222 8.11111111,14.2222222 C9.7591733,14.2222222 11.2548632,13.569839 12.3540235,12.5092299 C12.3749782,12.4803959 12.3997016,12.4527515 12.4262266,12.4262266 L12.5092299,12.3540235 C13.569839,11.2548632 14.2222222,9.7591733 14.2222222,8.11111111 C14.2222222,4.73603764 11.4861846,2 8.11111111,2 Z"
        />
    </svg>
);

export default React.memo(InputSearch);
